import { render, staticRenderFns } from "./TheHub.vue?vue&type=template&id=28951ab7"
import script from "./TheHub.vue?vue&type=script&lang=js"
export * from "./TheHub.vue?vue&type=script&lang=js"
import style0 from "~/assets/css/the-hub-style.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports